import { Routes } from '@angular/router';


import { adminGuard } from './auth/admin-guard.service';


import { tdsRoutes } from './tds-wizard/tds-wizard.routes';
import { authGuard } from './auth/auth.guard';

export const routes: Routes = [
  /**
   * Home.
   */
  {
    path: '',
    redirectTo: 'vehicles',
    pathMatch: 'full',
  },
  /**
   * Vehicle list.
   */
  {
    path: 'vehicles',
    canActivate: [authGuard],
    loadComponent: () => import('./vehicle-list/vehicle-list.component').then(m => m.VehicleListComponent),
  },
  /**
   * Vehicle detail.
   */
  {
    path: 'vehicles/:id',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./vehicle-detail/vehicle-detail.routes').then(
        (m) => m.vehicleDetailRoutes,
      ),
  },
  /**
   * Dealers not in this list are prohibited to use UCMIM and will instead be redirected to an error page.
   *
   * This is relevant for CROSS dealers.
   */
  {
    path: 'dealer-error',
    loadComponent: () => import('./dealer-error/dealer-error.component').then(m => m.DealerErrorComponent),
  },
  /**
   * Admin interface.
   */
  {
    path: 'admin',
    canActivate: [adminGuard],
    loadComponent: () => import('./admin/admin-interface.component').then(m => m.AdminInterfaceComponent),
  },
  /**
   * Help tab.
   */
  {
    path: 'help',
    canActivate: [authGuard],
    loadComponent: () => import('./help/help.component').then(m => m.HelpComponent),
  },
  /**
   * TDS wizard.
   */
  ...tdsRoutes,
];
